import React, {useState} from 'react';
import './i18n';
import {ChakraProvider, Box} from '@chakra-ui/react';
import Search from './components/Search';
import LoadingSpinner from './components/LoadingSpinner';
import ResultTable from './components/ResultTable';

const App = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [showResult, setShowResult] = useState(false);

  return (
      <ChakraProvider>
        <Box p={5}>
          <Search
              setLoading={setLoading}
              setResult={setResult}
              setShowResult={setShowResult}
          />
          {loading ? (<LoadingSpinner/>) : (
              showResult && (
                  <ResultTable
                      result={result}
                  />
              )
          )}
        </Box>
      </ChakraProvider>
  );
};

export default App;